import { endpoints } from "config";
import { CountriesRow } from "./CountriesList.types";
import { CellOptions } from "components/newFlexTable/Cell";

export const COUNTRIES_LIST_COLUMNS = {
  Id: "countries__Id" as const,
  DisplayValue: "countries__DisplayValue" as const,
  Active: "Countries__bActive" as const,
};

export const COUNTRIES_LIST_ENDPOINTS = {
  delete: endpoints.countries.delete,
  list: endpoints.countries.list,
};

/**
 * Cell width options for each column in the Countries list.
 */
export const rowCellOptions: Record<keyof CountriesRow, CellOptions> = {
  countries__Id: { width: "Small" },
  countries__DisplayValue: { width: "Large" },
  countries__ISOCode: { width: "Small" },
  countries__ISO2: { width: "Small" },
  countries__OrderNumber: { width: "Small" },
  countries__bActive: { width: "Small" },
  countries__AddDate: { width: "Medium2" },
  countries__AddedBy: { width: "Medium2" },
  countries__EditDate: { width: "Medium2" },
  countries__LastEditedBy: { width: "SemiLarge2" },
};
